"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TooltipBubble = _ref => {
  let {
    position,
    title,
    size,
    className,
    isBig,
    tipPosition,
    text
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("span", null, `${title}`, /*#__PURE__*/_react.default.createElement("i", {
    className: `icon tooltip ${isBig ? 'tooltip-big' : ''} is-tooltip-multiline ${tipPosition ? `is-tooltip-${tipPosition}` : ''} material-icons is-size-${size} ${className}`,
    style: {
      verticalAlign: `${position}`
    },
    "data-tooltip": `${text || ''}`,
    "data-testid": "tooltip-item"
  }, "info"));
};
TooltipBubble.propTypes = {
  position: _propTypes.default.string,
  title: _propTypes.default.string,
  size: _propTypes.default.string,
  fieldName: _propTypes.default.string,
  className: _propTypes.default.string,
  text: _propTypes.default.string,
  isBig: _propTypes.default.bool,
  tipPosition: _propTypes.default.string
};
TooltipBubble.defaultProps = {
  position: 'top',
  title: '',
  size: '5',
  fieldName: '',
  className: '',
  text: '',
  isBig: false,
  tipPosition: undefined
};
var _default = exports.default = TooltipBubble;
//# sourceMappingURL=TooltipBubble.js.map